module.exports = __webpack_public_path__ + "img/circle-check2.ae345747.svg";